// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3A7yV","error":"Textarea_error__2Nm2a","readonly":"Textarea_readonly__2GDAH","disabled":"Textarea_disabled__3WZ_r"};